module.exports = ".subtitle {\n    padding-top: 2vh;\n}"